import React, { Component } from 'react';
import strings from 'strings';
import listen from 'assets/listen.png';

import { getTestAudioPack } from './assets';

class Test extends Component {
  constructor(props) {
    super(props);
      const langCode = strings.getLanguage(); // 'no' | 'nn'
    this.assets = getTestAudioPack(
      langCode,
      props.ageGroup,
      props.testKeyType
    );
  }

  componentDidMount() {
    this.initializeAudio();
  }
  componentWillUnmount() {
    this.stopSounds();
    clearTimeout(this.timeout);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.currentStep !== this.props.currentStep) {
      this.startNewTask(this.props.currentStep);
    }
  }

    initializeAudio = () => {
    Object.values(this.assets).forEach((a) => a.load && a.load());
    this.timeout = setTimeout(
      () => this.startNewTask(this.props.currentStep),
      500
    );
  };

    startNewTask = (idx) => {
    this.stopSounds();
    const sound = this.assets[idx];
    if (sound) sound.play();
  };


  stopSounds = () => {
    for (const s of Object.values(this.assets)) {
      if (s.pause) s.pause();
      if (s.stop) s.stop();
    }
  };

  render() {
    return (
      <div className="SetningsMinne">
        <img className="listen-image" src={listen} alt="" />
        <p>{strings.sm_test_listen_repeat}</p>
      </div>
    );
  }
}
export default Test;
